import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import moment from 'moment/moment';


import './Resources/dashboard.css';
import axios from '../axios.js';
import Navbar from './Supportingfiles/navbar';
import Sidebar from './Supportingfiles/sidebar';
import Create_cash from './create_cash';


import Chart from "chart.js/auto";
import { Line, Bar } from "react-chartjs-2";

import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

//EXCEL DOWNLOAD IMPORT
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

function Admin_daysummary1(){

  

 //Report Print Function
 const componentRef = useref();
 const handlePrint = useReactToPrint({
   content: () => componentRef.current,
 });
  
 


 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const busyid=sessionStorage.getItem("BusyId00");
 const counterid=sessionStorage.getItem("CounterId00");

 /* PAGE VARIABLES */


 
{/* TRANSACTIONS TABLE COLUMNS MANAGEMENT VARIABLES START */}
const[cd_col1_val,setcd_col1_val] = useState(0);//column1
const[cd_col2_val,setcd_col2_val] = useState(0);//column2
const[cd_col3_val,setcd_col3_val] = useState(0);//column3
const[cd_col4_val,setcd_col4_val] = useState(0);//column4
const[cd_col5_val,setcd_col5_val] = useState(0);//column5
const[cd_col6_val,setcd_col6_val] = useState(0);//column6
const[cd_col7_val,setcd_col7_val] = useState(0);//column7
const[cd_col8_val,setcd_col8_val] = useState(0);//column8
const[cd_col9_val,setcd_col9_val] = useState(0);//column9
const[cd_col10_val,setcd_col10_val] = useState(0);//column10
const[cd_col11_val,setcd_col11_val] = useState(0);//column11
{/* const[cd_col12_val,setcd_col12_val] = useState(0);//column12
const[cd_col13_val,setcd_col13_val] = useState(0);//column13
const[cd_col14_val,setcd_col14_val] = useState(0);//column14 */}

{/* TRANSACTIONS TABLE COLUMNS MANAGEMENT VARIABLES END */}



 //Checking if Sessions are Set

// alert(logstatus,loguser,logadminid);
 //Sessions Not Set
 {/*if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))||((busyid==null)||(busyid==" "))||((counterid==null)||(counterid==" "))){
  
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   
 
    window.location.replace("/businesstools-login");
   }
  
   //Sessions Set
   else{

   */}
  

 
 
//Variables
const[data,setData] = useState([]);//SetData Variable

//Error Variable
const[errorvar,seterrorvar] = useState();
    
 
const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0]; // YYYY-MM-DD
};

//FILTER VARIABLES
const[filter_val,setfilter_val] = useState(0);
const[filter_start_date,setfilter_start_date] = useState(getTodayDate()); const updatefilter_start_date = (event) => { setfilter_start_date(event.target.value);}; const[filter_start_date_er,setfilter_start_date_er]=useState();
const[filter_end_date,setfilter_end_date] = useState(getTodayDate()); const updatefilter_end_date = (event) => { setfilter_end_date(event.target.value);}; const[filter_end_date_er,setfilter_end_date_er]=useState();

//Variables for pagination
const [currentPage, setCurrentPage] = useState(1);
const [pageNumber, setpageNumber] = useState(1);
    
useEffect(()=>{
   
  getData();
  
  },[])


 //SETTING DEFAULT STATE VARIABLES FOR CHART */
 

//DAY SUMMARY DETAILS
 const[opening_cash,setopening_cash] = useState(0);
 const[closing_cash,setclosing_cash] = useState(0);
 const[opening_bank,setopening_bank] = useState(0);
 const[closing_bank,setclosing_bank] = useState(0);

 //SALES SUMMARY
 //forward sales
 const[forward_cash_amt,setforward_cash_amt] = useState(0);
 const[forward_bank_amt,setforward_bank_amt] = useState(0);
 const[forward_booking_amt,setforward_booking_amt] = useState(0);
 const[forward_deposit_amt,setforward_deposit_amt] = useState(0);
 const[forward_balance_amt,setforward_balance_amt] = useState(0);
 const[forward_booked_qty,setforward_booked_qty] = useState(0);
 const[forward_dispatched_qty,setforward_dispatched_qty] = useState(0);
 const[forward_balance_qty,setforward_balance_qty] = useState(0);
 const[forward_avg_sales_amt,setforward_avg_sales_amt] = useState(0);
 //direct sales
 const[direct_cash_amt,setdirect_cash_amt] = useState(0);
 const[direct_bank_amt,setdirect_bank_amt] = useState(0);
 const[direct_booking_amt,setdirect_booking_amt] = useState(0);
 const[direct_deposit_amt,setdirect_deposit_amt] = useState(0);
 const[direct_balance_amt,setdirect_balance_amt] = useState(0);
 const[direct_booked_qty,setdirect_booked_qty] = useState(0);
 const[direct_dispatched_qty,setdirect_dispatched_qty] = useState(0);
 const[direct_balance_qty,setdirect_balance_qty] = useState(0);
 const[direct_avg_sales_amt,setdirect_avg_sales_amt] = useState(0);
 //broker sales
 const[broker_cash_amt,setbroker_cash_amt] = useState(0);
 const[broker_bank_amt,setbroker_bank_amt] = useState(0);
 const[broker_booking_amt,setbroker_booking_amt] = useState(0);
 const[broker_deposit_amt,setbroker_deposit_amt] = useState(0);
 const[broker_balance_amt,setbroker_balance_amt] = useState(0);
 const[broker_booked_qty,setbroker_booked_qty] = useState(0);
 const[broker_dispatched_qty,setbroker_dispatched_qty] = useState(0);
 const[broker_balance_qty,setbroker_balance_qty] = useState(0);
 const[broker_avg_sales_amt,setbroker_avg_sales_amt] = useState(0);
 //total
 const[total_cash_amt,settotal_cash_amt] = useState(0);
 const[total_bank_amt,settotal_bank_amt] = useState(0);
 const[total_booking_amt,settotal_booking_amt] = useState(0);
 const[total_deposit_amt,settotal_deposit_amt] = useState(0);
 const[total_balance_amt,settotal_balance_amt] = useState(0);
 const[total_booked_qty,settotal_booked_qty] = useState(0);
 const[total_dispatched_qty,settotal_dispatched_qty] = useState(0);
 const[total_balance_qty,settotal_balance_qty] = useState(0);
 const[total_avg_sales_amt,settotal_avg_sales_amt] = useState(0);
 //s30
 const[s30_cash_amt,sets30_cash_amt] = useState(0);
 const[s30_bank_amt,sets30_bank_amt] = useState(0);
 const[s30_booking_amt,sets30_booking_amt] = useState(0);
 const[s30_deposit_amt,sets30_deposit_amt] = useState(0);
 const[s30_balance_amt,sets30_balance_amt] = useState(0);
 const[s30_booked_qty,sets30_booked_qty] = useState(0);
 const[s30_dispatched_qty,sets30_dispatched_qty] = useState(0);
 const[s30_balance_qty,sets30_balance_qty] = useState(0);
 const[s30_avg_sales_amt,sets30_avg_sales_amt] = useState(0);
 //m30
 const[m30_cash_amt,setm30_cash_amt] = useState(0);
 const[m30_bank_amt,setm30_bank_amt] = useState(0);
 const[m30_booking_amt,setm30_booking_amt] = useState(0);
 const[m30_deposit_amt,setm30_deposit_amt] = useState(0);
 const[m30_balance_amt,setm30_balance_amt] = useState(0);
 const[m30_booked_qty,setm30_booked_qty] = useState(0);
 const[m30_dispatched_qty,setm30_dispatched_qty] = useState(0);
 const[m30_balance_qty,setm30_balance_qty] = useState(0);
 const[m30_avg_sales_amt,setm30_avg_sales_amt] = useState(0);
//brownsugar
 const[brownsugar_cash_amt,setbrownsugar_cash_amt] = useState(0);
 const[brownsugar_bank_amt,setbrownsugar_bank_amt] = useState(0);
 const[brownsugar_booking_amt,setbrownsugar_booking_amt] = useState(0);
 const[brownsugar_deposit_amt,setbrownsugar_deposit_amt] = useState(0);
 const[brownsugar_balance_amt,setbrownsugar_balance_amt] = useState(0);
 const[brownsugar_booked_qty,setbrownsugar_booked_qty] = useState(0);
 const[brownsugar_dispatched_qty,setbrownsugar_dispatched_qty] = useState(0);
 const[brownsugar_balance_qty,setbrownsugar_balance_qty] = useState(0);
 const[brownsugar_avg_sales_amt,setbrownsugar_avg_sales_amt] = useState(0);
 //molasses
 const[molasses_cash_amt,setmolasses_cash_amt] = useState(0);
 const[molasses_bank_amt,setmolasses_bank_amt] = useState(0);
 const[molasses_booking_amt,setmolasses_booking_amt] = useState(0);
 const[molasses_deposit_amt,setmolasses_deposit_amt] = useState(0);
 const[molasses_balance_amt,setmolasses_balance_amt] = useState(0);
 const[molasses_booked_qty,setmolasses_booked_qty] = useState(0);
 const[molasses_dispatched_qty,setmolasses_dispatched_qty] = useState(0);
 const[molasses_balance_qty,setmolasses_balance_qty] = useState(0);
 const[molasses_avg_sales_amt,setmolasses_avg_sales_amt] = useState(0);
 //baggase
 const[baggase_cash_amt,setbaggase_cash_amt] = useState(0);
 const[baggase_bank_amt,setbaggase_bank_amt] = useState(0);
 const[baggase_booking_amt,setbaggase_booking_amt] = useState(0);
 const[baggase_deposit_amt,setbaggase_deposit_amt] = useState(0);
 const[baggase_balance_amt,setbaggase_balance_amt] = useState(0);
 const[baggase_booked_qty,setbaggase_booked_qty] = useState(0);
 const[baggase_dispatched_qty,setbaggase_dispatched_qty] = useState(0);
 const[baggase_balance_qty,setbaggase_balance_qty] = useState(0);
 const[baggase_avg_sales_amt,setbaggase_avg_sales_amt] = useState(0);
 //pressmud
 const[pressmud_cash_amt,setpressmud_cash_amt] = useState(0);
 const[pressmud_bank_amt,setpressmud_bank_amt] = useState(0);
 const[pressmud_booking_amt,setpressmud_booking_amt] = useState(0);
 const[pressmud_deposit_amt,setpressmud_deposit_amt] = useState(0);
 const[pressmud_balance_amt,setpressmud_balance_amt] = useState(0);
 const[pressmud_booked_qty,setpressmud_booked_qty] = useState(0);
 const[pressmud_dispatched_qty,setpressmud_dispatched_qty] = useState(0);
 const[pressmud_balance_qty,setpressmud_balance_qty] = useState(0);
 const[pressmud_avg_sales_amt,setpressmud_avg_sales_amt] = useState(0);
 //ssuper
 const[ssuper_cash_amt,setssuper_cash_amt] = useState(0);
 const[ssuper_bank_amt,setssuper_bank_amt] = useState(0);
 const[ssuper_booking_amt,setssuper_booking_amt] = useState(0);
 const[ssuper_deposit_amt,setssuper_deposit_amt] = useState(0);
 const[ssuper_balance_amt,setssuper_balance_amt] = useState(0);
 const[ssuper_booked_qty,setssuper_booked_qty] = useState(0);
 const[ssuper_dispatched_qty,setssuper_dispatched_qty] = useState(0);
 const[ssuper_balance_qty,setssuper_balance_qty] = useState(0);
 const[ssuper_avg_sales_amt,setssuper_avg_sales_amt] = useState(0);
 //msuper 
 const[msuper_cash_amt,setmsuper_cash_amt] = useState(0);
 const[msuper_bank_amt,setmsuper_bank_amt] = useState(0);
 const[msuper_booking_amt,setmsuper_booking_amt] = useState(0);
 const[msuper_deposit_amt,setmsuper_deposit_amt] = useState(0);
 const[msuper_balance_amt,setmsuper_balance_amt] = useState(0);
 const[msuper_booked_qty,setmsuper_booked_qty] = useState(0);
 const[msuper_dispatched_qty,setmsuper_dispatched_qty] = useState(0);
 const[msuper_balance_qty,setmsuper_balance_qty] = useState(0);
 const[msuper_avg_sales_amt,setmsuper_avg_sales_amt] = useState(0);

//STOCK SUMMARY
 //total
 const[total_opening_stock,settotal_opening_stock] = useState(0);
 const[total_production,settotal_production] = useState(0);
 const[total_dispatch,settotal_dispatch] = useState(0);
 const[total_closing_stock,settotal_closing_stock] = useState(0);
 //s30
 const[s30_opening_stock,sets30_opening_stock] = useState(0);
 const[s30_production,sets30_production] = useState(0);
 const[s30_dispatch,sets30_dispatch] = useState(0);
 const[s30_closing_stock,sets30_closing_stock] = useState(0);
 //m30
 const[m30_opening_stock,setm30_opening_stock] = useState(0);
 const[m30_production,setm30_production] = useState(0);
 const[m30_dispatch,setm30_dispatch] = useState(0);
 const[m30_closing_stock,setm30_closing_stock] = useState(0);
 //sugarssuper
 const[sugarssuper_opening_stock,setsugarssuper_opening_stock] = useState(0);
 const[sugarssuper_production,setsugarssuper_production] = useState(0);
 const[sugarssuper_dispatch,setsugarssuper_dispatch] = useState(0);
 const[sugarssuper_closing_stock,setsugarssuper_closing_stock] = useState(0);
 //sugarmsuper
 const[sugarmsuper_opening_stock,setsugarmsuper_opening_stock] = useState(0);
 const[sugarmsuper_production,setsugarmsuper_production] = useState(0);
 const[sugarmsuper_dispatch,setsugarmsuper_dispatch] = useState(0);
 const[sugarmsuper_closing_stock,setsugarmsuper_closing_stock] = useState(0);
 //molasses
 const[molasses_opening_stock,setmolasses_opening_stock] = useState(0);
 const[molasses_production,setmolasses_production] = useState(0);
 const[molasses_dispatch,setmolasses_dispatch] = useState(0);
 const[molasses_closing_stock,setmolasses_closing_stock] = useState(0);
 //pressmud
 const[pressmud_opening_stock,setpressmud_opening_stock] = useState(0);
 const[pressmud_production,setpressmud_production] = useState(0);
 const[pressmud_dispatch,setpressmud_dispatch] = useState(0);
 const[pressmud_closing_stock,setpressmud_closing_stock] = useState(0);
 //baggase
 const[baggase_opening_stock,setbaggase_opening_stock] = useState(0);
 const[baggase_production,setbaggase_production] = useState(0);
 const[baggase_dispatch,setbaggase_dispatch] = useState(0);
 const[baggase_closing_stock,setbaggase_closing_stock] = useState(0);
 //brownsugar
 const[brownsugar_opening_stock,setbrownsugar_opening_stock] = useState(0);
 const[brownsugar_production,setbrownsugar_production] = useState(0);
 const[brownsugar_dispatch,setbrownsugar_dispatch] = useState(0);
 const[brownsugar_closing_stock,setbrownsugar_closing_stock] = useState(0);
 //caneseed
 const[caneseed_opening_stock,setcaneseed_opening_stock] = useState(0);
 const[caneseed_production,setcaneseed_production] = useState(0);
 const[caneseed_dispatch,setcaneseed_dispatch] = useState(0);
 const[caneseed_closing_stock,setcaneseed_closing_stock] = useState(0);


 const[booking_sale_value,setbooking_sale_value] = useState(0);
 const[sales_amount,setsales_amount] = useState(0);
 const[forward_booking_sale_value,setforward_booking_sale_value] = useState(0);
 const[forward_sales_amount,setforward_sales_amount] = useState(0);
 const[direct_booking_sale_value,setdirect_booking_sale_value] = useState(0);
 const[direct_sales_amount,setdirect_sales_amount] = useState(0);
 const[broker_booking_sale_value,setbroker_booking_sale_value] = useState(0);
 const[broker_sales_amount,setbroker_sales_amount] = useState(0);
 const[sugars_booking_sale_value,setsugars_booking_sale_value] = useState(0);
 const[sugars_sales_amount,setsugars_sales_amount] = useState(0);
 const[sugars30_booking_sale_value,setsugars30_booking_sale_value] = useState(0);
 const[sugars30_sales_amount,setsugars30_sales_amount] = useState(0);
 const[sugarm_booking_sale_value,setsugarm_booking_sale_value] = useState(0);
 const[sugarm_sales_amount,setsugarm_sales_amount] = useState(0);
 const[sugarm30_booking_sale_value,setsugarm30_booking_sale_value] = useState(0);
 const[sugarm30_sales_amount,setsugarm30_sales_amount] = useState(0);
 const[sugarssuper_booking_sale_value,setsugarssuper_booking_sale_value] = useState(0);
 const[sugarssuper_sales_amount,setsugarssuper_sales_amount] = useState(0);
 const[sugarmsuper_booking_sale_value,setsugarmsuper_booking_sale_value] = useState(0);
 const[sugarmsuper_sales_amount,setsugarmsuper_sales_amount] = useState(0);

 const[opening_stock,setopening_stock] = useState(0);
 const[closing_stock,setclosing_stock] = useState(0);
 const[sugars_opening_stock,setsugars_opening_stock] = useState(0);
 const[sugars_closing_stock,setsugars_closing_stock] = useState(0);
 const[sugars30_opening_stock,setsugars30_opening_stock] = useState(0);
 const[sugars30_closing_stock,setsugars30_closing_stock] = useState(0);
 const[sugarm_opening_stock,setsugarm_opening_stock] = useState(0);
 const[sugarm_closing_stock,setsugarm_closing_stock] = useState(0);
 const[sugarm30_opening_stock,setsugarm30_opening_stock] = useState(0);
 const[sugarm30_closing_stock,setsugarm30_closing_stock] = useState(0);
 /*const[sugarssuper_opening_stock,setsugarssuper_opening_stock] = useState(0);
 const[sugarssuper_closing_stock,setsugarssuper_closing_stock] = useState(0);
 const[sugarmsuper_opening_stock,setsugarmsuper_opening_stock] = useState(0);
 const[sugarmsuper_closing_stock,setsugarmsuper_closing_stock] = useState(0);*/

 const[cane_purchase_inqtl,setcane_purchase_inqtl] = useState(0);
 const[cane_purchase_intons,setcane_purchase_intons] = useState(0);
 const[cane_crushed_inqtl,setcane_crushed_inqtl] = useState(0);
 const[cane_crushed_intons,setcane_crushed_intons] = useState(0);
 const[sugar_s_inqtl,setsugar_s_inqtl] = useState(0);
 const[sugar_s_intons,setsugar_s_intons] = useState(0);
 const[sugar_s30_inqtl,setsugar_s30_inqtl] = useState(0);
 const[sugar_s30_intons,setsugar_s30_intons] = useState(0);
 const[sugar_m_inqtl,setsugar_m_inqtl] = useState(0);
 const[sugar_m_intons,setsugar_m_intons] = useState(0);
 const[sugar_m30_inqtl,setsugar_m30_inqtl] = useState(0);
 const[sugar_m30_intons,setsugar_m30_intons] = useState(0);
 const[molas_inqtl,setmolas_inqtl] = useState(0);
 const[molas_intons,setmolas_intons] = useState(0);
 const[baggase_inqtl,setbaggase_inqtl] = useState(0);
 const[baggase_intons,setbaggase_intons] = useState(0);
 const[pressmud_inqtl,setpressmud_inqtl] = useState(0);
 const[pressmud_intons,setpressmud_intons] = useState(0);
 const[caneseed_inqtl,setcaneseed_inqtl] = useState(0);
 const[caneseed_intons,setcaneseed_intons] = useState(0);
 const[sugar_ssuper_inqtl,setsugar_ssuper_inqtl] = useState(0);
 const[sugar_ssuper_intons,setsugar_ssuper_intons] = useState(0);
 const[sugar_msuper_inqtl,setsugar_msuper_inqtl] = useState(0);
 const[sugar_msuper_intons,setsugar_msuper_intons] = useState(0);
 const[brownsugar_inqtl,setbrownsugar_inqtl] = useState(0);
 const[brownsugar_intons,setbrownsugar_intons] = useState(0);

  const[avg_rs_value,setavg_rs_value] = useState(0);
  const[avg_rm_value,setavg_rm_value] = useState(0);
  const[avg_rs30_value,setavg_rs30_value] = useState(0);
  const[avg_rm30_value,setavg_rm30_value] = useState(0);
  const[avg_rmolasses_value,setavg_rmolasses_value] = useState(0);
  const[avg_rpressmud_value,setavg_rpressmud_value] = useState(0);
  const[avg_rbaggase_value,setavg_rbaggase_value] = useState(0);
  const[avg_rcaneseed_value,setavg_rcaneseed_value] = useState(0);
  const[avg_rssuper_value,setavg_rssuper_value] = useState(0);
  const[avg_rmsuper_value,setavg_rmsuper_value] = useState(0);
  const[avg_rbrownsugar_value,setavg_rbrownsugar_value] = useState(0);
  const[avg_rsugar_value,setavg_rsugar_value] = useState(0);
  const[avg_rother_value,setavg_rother_value] = useState(0);
 

//******************* GET DAYSUMMARY DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
    //Fetching Filter Variables
    const $filter_start_date = filter_start_date;const $filter_end_date = filter_end_date;

 axios.post("daysummarydefaultload", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
   
   //Filters
   Filter_val : filter_val,
   Filter_start_date : moment($filter_start_date).format('YYYY-MM-DD'),
   Filter_end_date : moment($filter_end_date).format('YYYY-MM-DD'),


  
//Code Edits for pagination
'page' : pageNumber




 })
 .then((response) => {


  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
     return;
  }
  //Success Data Fetched
  if(response.data.successvar==1){


   //Setting Data

    //data
    setopening_cash((response.data.opening_cash).toFixed(2));
    setclosing_cash((response.data.closing_cash).toFixed(2));
    setopening_bank((response.data.opening_bank).toFixed(2));
    setclosing_bank((response.data.closing_bank).toFixed(2));

    //SETTING NEW VALUES
    //SALES SUMMARY
    //forward
    setforward_cash_amt((response.data.forward_cash_amt).toFixed(2));
    setforward_bank_amt((response.data.forward_bank_amt).toFixed(2));
    setforward_booking_amt((response.data.forward_booking_amt).toFixed(2));
    setforward_deposit_amt((response.data.forward_deposit_amt).toFixed(2));
    setforward_balance_amt((response.data.forward_balance_amt).toFixed(2));
    setforward_booked_qty((response.data.forward_booked_qty).toFixed(2));
    setforward_dispatched_qty((response.data.forward_dispatched_qty).toFixed(2));
    setforward_balance_qty((response.data.forward_balance_qty).toFixed(2));
    setforward_avg_sales_amt((response.data.forward_avg_sales_amt).toFixed(2));
    //direct
    setdirect_cash_amt((response.data.direct_cash_amt).toFixed(2));
    setdirect_bank_amt((response.data.direct_bank_amt).toFixed(2));
    setdirect_booking_amt((response.data.direct_booking_amt).toFixed(2));
    setdirect_deposit_amt((response.data.direct_deposit_amt).toFixed(2));
    setdirect_balance_amt((response.data.direct_balance_amt).toFixed(2));
    setdirect_booked_qty((response.data.direct_booked_qty).toFixed(2));
    setdirect_dispatched_qty((response.data.direct_dispatched_qty).toFixed(2));
    setdirect_balance_qty((response.data.direct_balance_qty).toFixed(2));
    setdirect_avg_sales_amt((response.data.direct_avg_sales_amt).toFixed(2));
    //broker
    setbroker_cash_amt((response.data.broker_cash_amt).toFixed(2));
    setbroker_bank_amt((response.data.broker_bank_amt).toFixed(2));
    setbroker_booking_amt((response.data.broker_booking_amt).toFixed(2));
    setbroker_deposit_amt((response.data.broker_deposit_amt).toFixed(2));
    setbroker_balance_amt((response.data.broker_balance_amt).toFixed(2));
    setbroker_booked_qty((response.data.broker_booked_qty).toFixed(2));
    setbroker_dispatched_qty((response.data.broker_dispatched_qty).toFixed(2));
    setbroker_balance_qty((response.data.broker_balance_qty).toFixed(2));
    setbroker_avg_sales_amt((response.data.broker_avg_sales_amt).toFixed(2));
    //total
    settotal_cash_amt((response.data.total_cash_amt).toFixed(2));
    settotal_bank_amt((response.data.total_bank_amt).toFixed(2));
    settotal_booking_amt((response.data.total_booking_amt).toFixed(2));
    settotal_deposit_amt((response.data.total_deposit_amt).toFixed(2));
    settotal_balance_amt((response.data.total_balance_amt).toFixed(2));
    settotal_booked_qty((response.data.total_booked_qty).toFixed(2));
    settotal_dispatched_qty((response.data.total_dispatched_qty).toFixed(2));
    settotal_balance_qty((response.data.total_balance_qty).toFixed(2));
    settotal_avg_sales_amt((response.data.total_avg_sales_amt).toFixed(2));
    //s30
    sets30_cash_amt((response.data.s30_cash_amt).toFixed(2));
    sets30_bank_amt((response.data.s30_bank_amt).toFixed(2));
    sets30_booking_amt((response.data.s30_booking_amt).toFixed(2));
    sets30_deposit_amt((response.data.s30_deposit_amt).toFixed(2));
    sets30_balance_amt((response.data.s30_balance_amt).toFixed(2));
    sets30_booked_qty((response.data.s30_booked_qty).toFixed(2));
    sets30_dispatched_qty((response.data.s30_dispatched_qty).toFixed(2));
    sets30_balance_qty((response.data.s30_balance_qty).toFixed(2));
    sets30_avg_sales_amt((response.data.s30_avg_sales_amt).toFixed(2));
    //m30
    setm30_cash_amt((response.data.m30_cash_amt).toFixed(2));
    setm30_bank_amt((response.data.m30_bank_amt).toFixed(2));
    setm30_booking_amt((response.data.m30_booking_amt).toFixed(2));
    setm30_deposit_amt((response.data.m30_deposit_amt).toFixed(2));
    setm30_balance_amt((response.data.m30_balance_amt).toFixed(2));
    setm30_booked_qty((response.data.m30_booked_qty).toFixed(2));
    setm30_dispatched_qty((response.data.m30_dispatched_qty).toFixed(2));
    setm30_balance_qty((response.data.m30_balance_qty).toFixed(2));
    setm30_avg_sales_amt((response.data.m30_avg_sales_amt).toFixed(2));
    //brownsugar
    setbrownsugar_cash_amt((response.data.brownsugar_cash_amt).toFixed(2));
    setbrownsugar_bank_amt((response.data.brownsugar_bank_amt).toFixed(2));
    setbrownsugar_booking_amt((response.data.brownsugar_booking_amt).toFixed(2));
    setbrownsugar_deposit_amt((response.data.brownsugar_deposit_amt).toFixed(2));
    setbrownsugar_balance_amt((response.data.brownsugar_balance_amt).toFixed(2));
    setbrownsugar_booked_qty((response.data.brownsugar_booked_qty).toFixed(2));
    setbrownsugar_dispatched_qty((response.data.brownsugar_dispatched_qty).toFixed(2));
    setbrownsugar_balance_qty((response.data.brownsugar_balance_qty).toFixed(2));
    setbrownsugar_avg_sales_amt((response.data.brownsugar_avg_sales_amt).toFixed(2));
    //molasses
    setmolasses_cash_amt((response.data.molasses_cash_amt).toFixed(2));
    setmolasses_bank_amt((response.data.molasses_bank_amt).toFixed(2));
    setmolasses_booking_amt((response.data.molasses_booking_amt).toFixed(2));
    setmolasses_deposit_amt((response.data.molasses_deposit_amt).toFixed(2));
    setmolasses_balance_amt((response.data.molasses_balance_amt).toFixed(2));
    setmolasses_booked_qty((response.data.molasses_booked_qty).toFixed(2));
    setmolasses_dispatched_qty((response.data.molasses_dispatched_qty).toFixed(2));
    setmolasses_balance_qty((response.data.molasses_balance_qty).toFixed(2));
    setmolasses_avg_sales_amt((response.data.molasses_avg_sales_amt).toFixed(2));
    //baggase
    setbaggase_cash_amt((response.data.baggase_cash_amt).toFixed(2));
    setbaggase_bank_amt((response.data.baggase_bank_amt).toFixed(2));
    setbaggase_booking_amt((response.data.baggase_booking_amt).toFixed(2));
    setbaggase_deposit_amt((response.data.baggase_deposit_amt).toFixed(2));
    setbaggase_balance_amt((response.data.baggase_balance_amt).toFixed(2));
    setbaggase_booked_qty((response.data.baggase_booked_qty).toFixed(2));
    setbaggase_dispatched_qty((response.data.baggase_dispatched_qty).toFixed(2));
    setbaggase_balance_qty((response.data.baggase_balance_qty).toFixed(2));
    setbaggase_avg_sales_amt((response.data.baggase_avg_sales_amt).toFixed(2));
    //pressmud
    setpressmud_cash_amt((response.data.pressmud_cash_amt).toFixed(2));
    setpressmud_bank_amt((response.data.pressmud_bank_amt).toFixed(2));
    setpressmud_booking_amt((response.data.pressmud_booking_amt).toFixed(2));
    setpressmud_deposit_amt((response.data.pressmud_deposit_amt).toFixed(2));
    setpressmud_balance_amt((response.data.pressmud_balance_amt).toFixed(2));
    setpressmud_booked_qty((response.data.pressmud_booked_qty).toFixed(2));
    setpressmud_dispatched_qty((response.data.pressmud_dispatched_qty).toFixed(2));
    setpressmud_balance_qty((response.data.pressmud_balance_qty).toFixed(2));
    setpressmud_avg_sales_amt((response.data.pressmud_avg_sales_amt).toFixed(2));
    //ssuper
    setssuper_cash_amt((response.data.ssuper_cash_amt).toFixed(2));
    setssuper_bank_amt((response.data.ssuper_bank_amt).toFixed(2));
    setssuper_booking_amt((response.data.ssuper_booking_amt).toFixed(2));
    setssuper_deposit_amt((response.data.ssuper_deposit_amt).toFixed(2));
    setssuper_balance_amt((response.data.ssuper_balance_amt).toFixed(2));
    setssuper_booked_qty((response.data.ssuper_booked_qty).toFixed(2));
    setssuper_dispatched_qty((response.data.ssuper_dispatched_qty).toFixed(2));
    setssuper_balance_qty((response.data.ssuper_balance_qty).toFixed(2));
    setssuper_avg_sales_amt((response.data.ssuper_avg_sales_amt).toFixed(2)); 
    //msuper
    setmsuper_cash_amt((response.data.msuper_cash_amt).toFixed(2));
    setmsuper_bank_amt((response.data.msuper_bank_amt).toFixed(2));
    setmsuper_booking_amt((response.data.msuper_booking_amt).toFixed(2));
    setmsuper_deposit_amt((response.data.msuper_deposit_amt).toFixed(2));
    setmsuper_balance_amt((response.data.msuper_balance_amt).toFixed(2));
    setmsuper_booked_qty((response.data.msuper_booked_qty).toFixed(2));
    setmsuper_dispatched_qty((response.data.msuper_dispatched_qty).toFixed(2));
    setmsuper_balance_qty((response.data.msuper_balance_qty).toFixed(2));
    setmsuper_avg_sales_amt((response.data.msuper_avg_sales_amt).toFixed(2));

    //STOCK SUMMARY
    //s30
    sets30_opening_stock((response.data.s30_opening_stock).toFixed(2));
    sets30_production((response.data.s30_production).toFixed(2));
    sets30_dispatch((response.data.s30_dispatch).toFixed(2));
    sets30_closing_stock((response.data.s30_closing_stock).toFixed(2));
    //m30
    setm30_opening_stock((response.data.m30_opening_stock).toFixed(2));
    setm30_production((response.data.m30_production).toFixed(2));
    setm30_dispatch((response.data.m30_dispatch).toFixed(2));
    setm30_closing_stock((response.data.m30_closing_stock).toFixed(2));
    //sugarssuper
    setsugarssuper_opening_stock((response.data.sugarssuper_opening_stock).toFixed(2));
    setsugarssuper_production((response.data.sugarssuper_production).toFixed(2));
    setsugarssuper_dispatch((response.data.sugarssuper_dispatch).toFixed(2));
    setsugarssuper_closing_stock((response.data.sugarssuper_closing_stock).toFixed(2));
    //sugarmsuper
    setsugarmsuper_opening_stock((response.data.sugarmsuper_opening_stock).toFixed(2));
    setsugarmsuper_production((response.data.sugarmsuper_production).toFixed(2));
    setsugarmsuper_dispatch((response.data.sugarmsuper_dispatch).toFixed(2));
    setsugarmsuper_closing_stock((response.data.sugarmsuper_closing_stock).toFixed(2));
    //molasses
    setmolasses_opening_stock((response.data.molasses_opening_stock).toFixed(2));
    setmolasses_production((response.data.molasses_production).toFixed(2));
    setmolasses_dispatch((response.data.molasses_dispatch).toFixed(2));
    setmolasses_closing_stock((response.data.molasses_closing_stock).toFixed(2));
    //pressmud
    setpressmud_opening_stock((response.data.pressmud_opening_stock).toFixed(2));
    setpressmud_production((response.data.pressmud_production).toFixed(2));
    setpressmud_dispatch((response.data.pressmud_dispatch).toFixed(2));
    setpressmud_closing_stock((response.data.pressmud_closing_stock).toFixed(2));
    //baggase
    setbaggase_opening_stock((response.data.baggase_opening_stock).toFixed(2));
    setbaggase_production((response.data.baggase_production).toFixed(2));
    setbaggase_dispatch((response.data.baggase_dispatch).toFixed(2));
    setbaggase_closing_stock((response.data.baggase_closing_stock).toFixed(2));
    //brownsugar
    setbrownsugar_opening_stock((response.data.brownsugar_opening_stock).toFixed(2));
    setbrownsugar_production((response.data.brownsugar_production).toFixed(2));
    setbrownsugar_dispatch((response.data.brownsugar_dispatch).toFixed(2));
    setbrownsugar_closing_stock((response.data.brownsugar_closing_stock).toFixed(2));
    //caneseed
    setcaneseed_opening_stock((response.data.caneseed_opening_stock).toFixed(2));
    setcaneseed_production((response.data.caneseed_production).toFixed(2));
    setcaneseed_dispatch((response.data.caneseed_dispatch).toFixed(2));
    setcaneseed_closing_stock((response.data.caneseed_closing_stock).toFixed(2));
    //total
    settotal_opening_stock((response.data.total_opening_stock).toFixed(2));
    settotal_production((response.data.total_production).toFixed(2));
    settotal_dispatch((response.data.total_dispatch).toFixed(2));
    settotal_closing_stock((response.data.total_closing_stock).toFixed(2));

    setbooking_sale_value((response.data.booking_sale_value).toFixed(2));
    setsales_amount((response.data.sales_amount).toFixed(2));

    setforward_booking_sale_value((response.data.forward_booking_sale_value).toFixed(2));
    setforward_sales_amount((response.data.forward_sales_amount).toFixed(2));
    setdirect_booking_sale_value((response.data.direct_booking_sale_value).toFixed(2));
    setdirect_sales_amount((response.data.direct_sales_amount).toFixed(2));
    setbroker_booking_sale_value((response.data.broker_booking_sale_value).toFixed(2));
    setbroker_sales_amount((response.data.broker_sales_amount).toFixed(2));
    setsugars_booking_sale_value((response.data.sugars_booking_sale_value).toFixed(2));
    setsugars_sales_amount((response.data.sugars_sales_amount).toFixed(2));
    setsugars30_booking_sale_value((response.data.sugars30_booking_sale_value).toFixed(2));
    setsugars30_sales_amount((response.data.sugars30_sales_amount).toFixed(2));
    setsugarm_booking_sale_value((response.data.sugarm_booking_sale_value).toFixed(2));
    setsugarm_sales_amount((response.data.sugarm_sales_amount).toFixed(2));
    setsugarm30_booking_sale_value((response.data.sugarm30_booking_sale_value).toFixed(2));
    setsugarm30_sales_amount((response.data.sugarm30_sales_amount).toFixed(2));
    setsugarssuper_booking_sale_value((response.data.sugarssuper_booking_sale_value).toFixed(2));
    setsugarssuper_sales_amount((response.data.sugarssuper_sales_amount).toFixed(2));
    setsugarmsuper_booking_sale_value((response.data.sugarmsuper_booking_sale_value).toFixed(2));
    setsugarmsuper_sales_amount((response.data.sugarmsuper_sales_amount).toFixed(2));


    setopening_stock((response.data.opening_stock).toFixed(2));
    setclosing_stock((response.data.closing_stock).toFixed(2));
    setsugars_opening_stock((response.data.sugars_opening_stock).toFixed(2));
    setsugars_closing_stock((response.data.sugars_closing_stock).toFixed(2));
    setsugars30_opening_stock((response.data.sugars30_opening_stock).toFixed(2));
    setsugars30_closing_stock((response.data.sugars30_closing_stock).toFixed(2));
    setsugarm_opening_stock((response.data.sugarm_opening_stock).toFixed(2));
    setsugarm_closing_stock((response.data.sugarm_closing_stock).toFixed(2));
    setsugarm30_opening_stock((response.data.sugarm30_opening_stock).toFixed(2));
    setsugarm30_closing_stock((response.data.sugarm30_closing_stock).toFixed(2));
    setsugarssuper_opening_stock((response.data.sugarssuper_opening_stock).toFixed(2));
    setsugarssuper_closing_stock((response.data.sugarssuper_closing_stock).toFixed(2));
    setsugarmsuper_opening_stock((response.data.sugarmsuper_opening_stock).toFixed(2));
    setsugarmsuper_closing_stock((response.data.sugarmsuper_closing_stock).toFixed(2));

    setcane_purchase_inqtl((response.data.cane_purchase_inqtl).toFixed(2));
    setcane_purchase_intons((response.data.cane_purchase_intons).toFixed(2));
    setcane_crushed_inqtl((response.data.cane_crushed_inqtl).toFixed(2));
    setcane_crushed_intons((response.data.cane_crushed_intons).toFixed(2));
    setsugar_s_inqtl((response.data.sugar_s_inqtl).toFixed(2));
    setsugar_s_intons((response.data.sugar_s_intons).toFixed(2));
    setsugar_s30_inqtl((response.data.sugar_s30_inqtl).toFixed(2));
    setsugar_s30_intons((response.data.sugar_s30_intons).toFixed(2));
    setsugar_m_inqtl((response.data.sugar_m_inqtl).toFixed(2));
    setsugar_m_intons((response.data.sugar_m_intons).toFixed(2));
    setsugar_m30_inqtl((response.data.sugar_m30_inqtl).toFixed(2));
    setsugar_m30_intons((response.data.sugar_m30_intons).toFixed(2));
    setmolas_inqtl((response.data.molas_inqtl).toFixed(2));
    setmolas_intons((response.data.molas_intons).toFixed(2));
    setpressmud_inqtl((response.data.pressmud_inqtl).toFixed(2));
    setpressmud_intons((response.data.pressmud_intons).toFixed(2));
    setbaggase_inqtl((response.data.baggase_inqtl).toFixed(2));
    setbaggase_intons((response.data.baggase_intons).toFixed(2));
    setcaneseed_inqtl((response.data.caneseed_inqtl).toFixed(2));
    setcaneseed_intons((response.data.caneseed_intons).toFixed(2));
    setsugar_ssuper_inqtl((response.data.sugar_ssuper_inqtl).toFixed(2));
    setsugar_ssuper_intons((response.data.sugar_ssuper_intons).toFixed(2));
    setsugar_msuper_inqtl((response.data.sugar_msuper_inqtl).toFixed(2));
    setsugar_msuper_intons((response.data.sugar_msuper_intons).toFixed(2));
    setbrownsugar_inqtl((response.data.brownsugar_inqtl).toFixed(2));
    setbrownsugar_intons((response.data.brownsugar_intons).toFixed(2));
    
    setavg_rs_value((response.data.avg_rs_value).toFixed(2));
    setavg_rm_value((response.data.avg_rm_value).toFixed(2));
    setavg_rs30_value((response.data.avg_rs30_value).toFixed(2));
    setavg_rm30_value((response.data.avg_rm30_value).toFixed(2));
    setavg_rmolasses_value((response.data.avg_rmolasses_value).toFixed(2));
    setavg_rpressmud_value((response.data.avg_rpressmud_value).toFixed(2));
    setavg_rbaggase_value((response.data.avg_rbaggase_value).toFixed(2));
    setavg_rcaneseed_value((response.data.avg_rcaneseed_value).toFixed(2));
    setavg_rssuper_value((response.data.avg_rssuper_value).toFixed(2));
    setavg_rmsuper_value((response.data.avg_rmsuper_value).toFixed(2));
    setavg_rbrownsugar_value((response.data.avg_rbrownsugar_value).toFixed(2));
    setavg_rsugar_value((response.data.avg_rsugar_value).toFixed(2));
    setavg_rother_value((response.data.avg_rother_value).toFixed(2));

  }
   //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){
    setfilter_start_date_er(response.data.validatorerror.Filter_start_date);
    setfilter_end_date_er(response.data.validatorerror.Filter_end_date);
   
  }

  //Data Violation
  if(response.data.error==102){ 
  
    setfilter_start_date_er(response.data.filter_start_date_er);
    setfilter_end_date_er(response.data.filter_end_date_er);
   
  }
  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* GET CASHBOOK DATA FUNCTION END  ********************//



return(
    <>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>React App</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

      <Sidebar />
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

      
             
          <div className="content-wrapper pb-0">



            <div className="page-header flex-wrap">
            <div className="header-left"></div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">DASHBOARD</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                  {/*}  <p className="m-0">ADE-00234</p> */}
                  </a>
                </div>
               
              </div>
            </div>

          
              

              {/* bpm TRANSACTIONS TABLE SECTION START */}
                  
             <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title"><h4 className="card-title">
  DASHBOARD AS ON{' '}
  <span className="text-primary">
    {new Date().toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      weekday: 'long'
    })}
  </span>
</h4>
</h4>
                    <p className="card-description">dashboard
                    </p>


                    <div className="table-responsive" id="reports" ref={componentRef}>
                    <br/><br/>
                      <table className="table table-bordered table-hover">
                        <thead>
                          <tr>
                            <th style={{fontWeight:"bold", backgroundColor:"#00a831", color:"#ffffff", textAlign:"center"}} colSpan={4}>SUMMARY OF BOOKS</th>
                          </tr>
                        
                   
                         </thead>
                         </table>

                         <table className="table table-bordered table-hover">
                         <thead>
                         <tr>
                            <th  style={{fontWeight:"bold", backgroundColor:"#96f4b1", textAlign:"center"}} colSpan={9}>SALES SUMMARY</th>
                          </tr>
                          <tr>
                            <th  style={{fontWeight:"bold", backgroundColor:"#f9f9f9", textAlign:"center"}} colSpan={9}>MODE WISE SALES</th>
                          </tr>
                         <tr style={{textAlign:"left"}}>
                          <th><b>Particular</b></th>
                          <th><b>BPM</b></th>
                          <th><b>Bank</b></th>
                          <th><b>Booking Amt</b></th>
                          <th><b>Deposit Amt</b></th>
                          <th><b>Balance Amt</b></th>
                          <th><b>Booked Qty</b></th>
                          <th><b>Dispatched Qty</b></th>
                          {/*<th><b>Balance Qty</b></th>*/}
                          <th><b>Avg. Sales Rate</b></th>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Broker</b></td>
                          <td>{broker_cash_amt}</td>
                          <td>{broker_bank_amt}</td>
                          <td>{broker_booking_amt}</td>
                          <td>{broker_deposit_amt}</td>
                          <td>{broker_balance_amt}</td>
                          <td>{broker_booked_qty} Qtl.</td>
                          <td>{broker_dispatched_qty} Qtl.</td>
                          {/*<td>{broker_balance_qty} Qtl.</td>*/}
                          <td>{broker_avg_sales_amt}</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Forward</b></td>
                          <td>{forward_cash_amt}</td>
                          <td>{forward_bank_amt}</td>
                          <td>{forward_booking_amt}</td>
                          <td>{forward_deposit_amt}</td>
                          <td>{forward_balance_amt}</td>
                          <td>{forward_booked_qty} Qtl.</td>
                          <td>{forward_dispatched_qty} Qtl.</td>
                          {/*<td>{forward_balance_qty} Qtl.</td>*/}
                          <td>{forward_avg_sales_amt}</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Direct</b></td>
                          <td>{direct_cash_amt}</td>
                          <td>{direct_bank_amt}</td>
                          <td>{direct_booking_amt}</td>
                          <td>{direct_deposit_amt}</td>
                          <td>{direct_balance_amt}</td>
                          <td>{direct_booked_qty} Qtl.</td>
                          <td>{direct_dispatched_qty} Qtl.</td>
                          {/*<td>{direct_balance_qty} Qtl.</td>*/}
                          <td>{direct_avg_sales_amt}</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Total</b></td>
                          <td>{total_cash_amt}</td>
                          <td>{total_bank_amt}</td>
                          <td>{total_booking_amt}</td>
                          <td>{total_deposit_amt}</td>
                          <td>{total_balance_amt}</td>
                          <td>{total_booked_qty} Qtl.</td>
                          <td>{total_dispatched_qty} Qtl.</td>
                          {/*<td>{total_balance_qty} Qtl.</td>*/}
                          <td>{total_avg_sales_amt}</td>
                          </tr>
                          <tr>
                            <th  style={{fontWeight:"bold", backgroundColor:"#f9f9f9", textAlign:"center"}} colSpan={9}>PRODUCT WISE SALES</th>
                          </tr>
                         <tr style={{textAlign:"left"}}>
                          <th><b>Particular</b></th>
                          <th><b>BPM</b></th>
                          <th><b>Bank</b></th>
                          <th><b>Booking Amt</b></th>
                          <th><b>Deposit Amt</b></th>
                          <th><b>Balance Amt</b></th>
                          <th><b>Booked Qty</b></th>
                          <th><b>Dispatched Qty</b></th>
                          {/*<th><b>Balance Qty</b></th>*/}
                          <th><b>Avg. Sales Rate</b></th>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>S-30</b></td>
                          <td>{s30_cash_amt}</td>
                          <td>{s30_bank_amt}</td>
                          <td>{s30_booking_amt}</td>
                          <td>{s30_deposit_amt}</td>
                          <td>{s30_balance_amt}</td>
                          <td>{s30_booked_qty} Qtl.</td>
                          <td>{s30_dispatched_qty} Qtl.</td>
                          {/*<td>{s30_balance_qty} Qtl.</td>*/}
                          <td>{s30_avg_sales_amt}</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>M-30</b></td>
                          <td>{m30_cash_amt}</td>
                          <td>{m30_bank_amt}</td>
                          <td>{m30_booking_amt}</td>
                          <td>{m30_deposit_amt}</td>
                          <td>{m30_balance_amt}</td>
                          <td>{m30_booked_qty} Qtl.</td>
                          <td>{m30_dispatched_qty} Qtl.</td>
                          {/*<td>{m30_balance_qty} Qtl.</td>*/}
                          <td>{m30_avg_sales_amt}</td>
                          </tr>
                         <tr style={{textAlign:"left"}}>
                          <td><b>Brown Sugar</b></td>
                          <td>{brownsugar_cash_amt}</td>
                          <td>{brownsugar_bank_amt}</td>
                          <td>{brownsugar_booking_amt}</td>
                          <td>{brownsugar_deposit_amt}</td>
                          <td>{brownsugar_balance_amt}</td>
                          <td>{brownsugar_booked_qty} Qtl.</td>
                          <td>{brownsugar_dispatched_qty} Qtl.</td>
                          {/*<td>{brownsugar_balance_qty} Qtl.</td>*/}
                          <td>{brownsugar_avg_sales_amt}</td>
                          </tr>
                        <tr style={{textAlign:"left"}}>
                          <td><b>Molasses</b></td>
                          <td>{molasses_cash_amt}</td>
                          <td>{molasses_bank_amt}</td>
                          <td>{molasses_booking_amt}</td>
                          <td>{molasses_deposit_amt}</td>
                          <td>{molasses_balance_amt}</td>
                          <td>{molasses_booked_qty} Qtl.</td>
                          <td>{molasses_dispatched_qty} Qtl.</td>
                          {/*<td>{molasses_balance_qty} Qtl.</td>*/}
                          <td>{molasses_avg_sales_amt}</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Baggase</b></td>
                          <td>{baggase_cash_amt}</td>
                          <td>{baggase_bank_amt}</td>
                          <td>{baggase_booking_amt}</td>
                          <td>{baggase_deposit_amt}</td>
                          <td>{baggase_balance_amt}</td>
                          <td>{baggase_booked_qty} Qtl.</td>
                          <td>{baggase_dispatched_qty} Qtl.</td>
                         {/*} <td>{baggase_balance_qty} Qtl.</td>*/}
                          <td>{baggase_avg_sales_amt}</td>
                          </tr>
                         <tr style={{textAlign:"left"}}>
                          <td><b>Press Mud</b></td>
                          <td>{pressmud_cash_amt}</td>
                          <td>{pressmud_bank_amt}</td>
                          <td>{pressmud_booking_amt}</td>
                          <td>{pressmud_deposit_amt}</td>
                          <td>{pressmud_balance_amt}</td>
                          <td>{pressmud_booked_qty} Qtl.</td>
                          <td>{pressmud_dispatched_qty} Qtl.</td>
                         {/*} <td>{pressmud_balance_qty} Qtl.</td>*/}
                          <td>{pressmud_avg_sales_amt}</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Super S</b></td>
                          <td>{ssuper_cash_amt}</td>
                          <td>{ssuper_bank_amt}</td>
                          <td>{ssuper_booking_amt}</td>
                          <td>{ssuper_deposit_amt}</td>
                          <td>{ssuper_balance_amt}</td>
                          <td>{ssuper_booked_qty} Qtl.</td>
                          <td>{ssuper_dispatched_qty} Qtl.</td>
                          {/*<td>{ssuper_balance_qty} Qtl.</td>*/}
                          <td>{ssuper_avg_sales_amt}</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Super M</b></td>
                          <td>{msuper_cash_amt}</td>
                          <td>{msuper_bank_amt}</td>
                          <td>{msuper_booking_amt}</td>
                          <td>{msuper_deposit_amt}</td>
                          <td>{msuper_balance_amt}</td>
                          <td>{msuper_booked_qty} Qtl.</td>
                          <td>{msuper_dispatched_qty} Qtl.</td>
                         {/*} <td>{msuper_balance_qty} Qtl.</td>*/}
                          <td>{msuper_avg_sales_amt}</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Total</b></td>
                          <td>{total_cash_amt}</td>
                          <td>{total_bank_amt}</td>
                          <td>{total_booking_amt}</td>
                          <td>{total_deposit_amt}</td>
                          <td>{total_balance_amt}</td>
                          <td>{total_booked_qty} Qtl.</td>
                          <td>{total_dispatched_qty} Qtl.</td>
                          {/*<td>{total_balance_qty} Qtl.</td>*/}
                          <td>{total_avg_sales_amt}</td>
                          </tr>
                         </thead>
                         </table>

                         <table className="table table-bordered table-hover">
                         <thead>
                         <tr>
                            <th  style={{fontWeight:"bold", backgroundColor:"#96f4b1", textAlign:"center"}} colSpan={5}>STOCK SUMMARY</th>
                          </tr>
                          
                         <tr style={{textAlign:"left"}}>
                          <th><b>Product Name </b></th>
                          <th><b>Opening Stock</b></th>
                          <th><b>Production</b></th>
                          <th><b>Dispatch</b></th>
                          <th><b>Closing Stock</b></th>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Sugar S30</b></td>
                          <td>{s30_opening_stock} Qtl.</td>
                          <td>{s30_production} Qtl.</td>
                          <td>{s30_dispatch} Qtl.</td>
                          <td>{s30_closing_stock} Qtl.</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Sugar M30</b></td>
                          <td>{m30_opening_stock} Qtl.</td>
                          <td>{m30_production} Qtl.</td>
                          <td>{m30_dispatch} Qtl.</td>
                          <td>{m30_closing_stock} Qtl.</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Sugar S Super</b></td>
                          <td>{sugarssuper_opening_stock} Qtl.</td>
                          <td>{sugarssuper_production} Qtl.</td>
                          <td>{sugarssuper_dispatch} Qtl.</td>
                          <td>{sugarssuper_closing_stock} Qtl.</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Sugar M Super</b></td>
                          <td>{sugarmsuper_opening_stock} Qtl.</td>
                          <td>{sugarmsuper_production} Qtl.</td>
                          <td>{sugarmsuper_dispatch} Qtl.</td>
                          <td>{sugarmsuper_closing_stock} Qtl.</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Molasses</b></td>
                          <td>{molasses_opening_stock} Qtl.</td>
                          <td>{molasses_production} Qtl.</td>
                          <td>{molasses_dispatch} Qtl.</td>
                          <td>{molasses_closing_stock} Qtl.</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Press Mud</b></td>
                          <td>{pressmud_opening_stock} Qtl.</td>
                          <td>{pressmud_production} Qtl.</td>
                          <td>{pressmud_dispatch} Qtl.</td>
                          <td>{pressmud_closing_stock} Qtl.</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Baggase</b></td>
                          <td>{baggase_opening_stock} Qtl.</td>
                          <td>{baggase_production} Qtl.</td>
                          <td>{baggase_dispatch} Qtl.</td>
                          <td>{baggase_closing_stock} Qtl.</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Brown Sugar</b></td>
                          <td>{brownsugar_opening_stock} Qtl.</td>
                          <td>{brownsugar_production} Qtl.</td>
                          <td>{brownsugar_dispatch} Qtl.</td>
                          <td>{brownsugar_closing_stock} Qtl.</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Cane Seed</b></td>
                          <td>{caneseed_opening_stock} Qtl.</td>
                          <td>{caneseed_production} Qtl.</td>
                          <td>{caneseed_dispatch} Qtl.</td>
                          <td>{caneseed_closing_stock} Qtl.</td>
                          </tr>
                          <tr style={{textAlign:"left"}}>
                          <td><b>Total</b></td>
                          <td>{total_opening_stock} Qtl.</td>
                          <td>{total_production} Qtl.</td>
                          <td>{total_dispatch} Qtl.</td>
                          <td>{total_closing_stock} Qtl.</td>
                          </tr>
                          </thead>
                          </table>
                      
                         <table className="table table-bordered table-hover">
                         <thead>
                          <tr>
                            <th  style={{fontWeight:"bold", backgroundColor:"#96f4b1", textAlign:"center"}} colSpan={3}>PRODUCTION SUMMARY</th>
                          </tr>
                              <tr  style={{textAlign:"left"}}>
                          <td><b>Cane Purchase (in Qtl.): </b>{cane_purchase_inqtl} Qtl.</td>
                          <td><b>Cane Crushed (in Qtl.): </b> {cane_crushed_inqtl} Qtl.</td>
                          <td><b>Cane Seed prod. </b>{caneseed_inqtl} Qtl. (<span class="text-primary">{avg_rcaneseed_value} %</span>)</td>
                          </tr>




                          <tr  style={{textAlign:"left"}}>
                          <td><b>Sugar S Prod. (in Qtl.): </b>{sugar_s_inqtl} Qtl. (<span class="text-primary">{avg_rs_value} %</span>)</td>
                          <td><b>Sugar S30 Prod. (in Qtl.): </b> {sugar_s30_inqtl} Qtl. (<span class="text-primary">{avg_rs30_value} %</span>)</td>
                          <td><b>Sugar M30 Prod. (in Qtl.): </b> {sugar_m30_inqtl} Qtl. (<span class="text-primary">{avg_rm30_value} %</span>)</td>
                          </tr>
                          <tr  style={{textAlign:"left"}}>
                          <td><b>Sugar S Super Prod. (in Qtl.): </b>{sugar_ssuper_inqtl} Qtl. (<span class="text-primary">{avg_rssuper_value} %</span>)</td>
                          <td><b>Sugar M Super Prod. (in Qtl.): </b> {sugar_msuper_inqtl} Qtl. (<span class="text-primary">{avg_rmsuper_value} %</span>)</td>
                          <td><b>Molasses Prod. (in Qtl.): </b> {molas_inqtl} Qtl. (<span class="text-primary">{avg_rmolasses_value} %</span>)</td>
                          </tr>
                          <tr  style={{textAlign:"left"}}>
                          <td><b>Press Mud Prod. (in Qtl.): </b>{pressmud_inqtl} Qtl. (<span class="text-primary">{avg_rpressmud_value} %</span>)</td>
                          <td><b>Baggase Prod. (in Qtl.): </b> {baggase_inqtl} Qtl. (<span class="text-primary">{avg_rbaggase_value} %</span>)</td>
                          <td><b>Brown Sugar Prod. (in Qtl.): </b> {brownsugar_inqtl} Qtl. (<span class="text-primary">{avg_rbrownsugar_value} %</span>)</td>
                          </tr>
                        
                        
                       
                      
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                           
                          </tr>
                           <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                           
                          </tr>
                           <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                           
                          </tr>
                        </thead>
                        <tbody>
                      
                        </tbody>
                      </table>
                    </div>
                    
                    <br/><br/>

                    <button class="btn btn-light" onClick={handlePrint}><i class="mdi mdi-cloud-print text-dark"></i></button>
                        
                  </div>
                </div>
              </div>

            {/* bpm TRANSACTIONS TABLE SECTION END */}

            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}
}
export default Admin_daysummary1;